module.exports = __webpack_public_path__ + "media/images/bg/shapes/tests-24b6bd8aee90f18f2d1daf4a701bd5bd.svg";